export default "__VITE_ASSET__BH2UTh3J__"